module.exports = __webpack_public_path__ + "img/ycg-ico3.fb205425.png";